import { showNotification } from "../../alert/alert.js";

export default function setup() {
  function loadAvatarView() {
    // Make an AJAX call to load the form from the controller
    $.ajax({
      url: "/Account/GetAvatarImage",
      type: "GET",
      success: function (response) {
        // Load the form into the container
        $(".dealer-avatar-container").html(response);
        initializeAvatarImageUpdateFormHandlers();
      },
      error: function (error) {
        showNotification("Avatar was not loaded", "error");
      },
    });
  }

  loadAvatarView();

  function loadPasswordChangeView() {
    // Make an AJAX call to load the form from the controller
    $.ajax({
      url: "/DealerEditProfile/GetChangePasswordForm",
      type: "GET",
      success: function (response) {
        // Load the form into the container
        $(".dealer-password-container").html(response);
        initializeChangePasswordFormHandlers();
      },
      error: function (error) {
        showNotification("Set new password form was not loaded", "error");
      },
    });
  }

  loadPasswordChangeView();

  function initializeChangePasswordFormHandlers() {
    // Password form is now only used for data collection
    // The actual submission happens through SaveAllChanges endpoint
    // No standalone save needed
  }

  function initializeChangeSocialNetworksFormHandlers() {
    $("#set-social-networks-for-user-button").on("click", function () {
      // Collect the form data
      var form = $("#SetSocialNetworksForUser");
      var formData = form.serialize();

      // Send the form via AJAX
      $.ajax({
        url: "/DealerEditProfile/SetSocialNetworksForUser", // The action method that handles the form submission
        type: "POST",
        data: formData,
        success: function (response) {
          $(".dealer-social-networks-container").html(response);
          initializeChangeSocialNetworksFormHandlers();
        },
        error: function (xhr, status, error) {
          showNotification("Social networks were not set", "error");
        },
      });
    });
  }

  function initializeAvatarImageUpdateFormHandlers() {
    // Initially disable the button
    $("#updateAvatarImage").prop("disabled", true);

    // Check when the file input changes
    $("#AvatarImageFileAttachment").on("change", function () {
      var fileInput = $(this);
      var file = fileInput[0].files[0];
      var maxSize = 1024 * 1024; // 1MB in bytes

      // Check file size
      if (file && file.size > maxSize) {
        showNotification("File size must be less than 1MB", "error");
        fileInput.val(""); // Clear the file input
        $("#updateAvatarImage").prop("disabled", true);
        return;
      }

      // Enable the button if a file is selected, otherwise disable it
      if (fileInput.val()) {
        $("#updateAvatarImage").prop("disabled", false);
      } else {
        $("#updateAvatarImage").prop("disabled", true);
      }
    });

    $("#updateAvatarImage").on("click", function (e) {
      if ($(this).prop("disabled")) {
        e.preventDefault(); // Prevent the click event from going further
        triggerUpdateOfDealerProfile();
        return;
      }

      // Add loading state
      const $button = $(this);
      $button.addClass("uploading").prop("disabled", true).text("Uploading...");

      // Collect the form data
      // Collect the form data, including the file
      var form = $("#avatarImageUpdateForm")[0]; // Get the raw DOM element
      var formData = new FormData(form); // Create a FormData object

      // Send the form via AJAX
      $.ajax({
        url: "/Account/UpdateAvatarImage", // The action method that handles the form submission
        type: "POST",
        data: formData,
        processData: false, // Important: Prevent jQuery from automatically transforming the data into a query string
        contentType: false, // Important: Let the browser set the `Content-Type` with `multipart/form-data` boundary
        success: function (response) {
          $(".dealer-avatar-container").html(response);
          initializeAvatarImageUpdateFormHandlers();

          // Show success notification
          showNotification("Avatar updated successfully!", "success");

          // Force refresh all avatar images to show the new upload immediately
          setTimeout(function () {
            document
              .querySelectorAll("img[xpc-member-avatar]")
              .forEach(function (img) {
                const currentSrc = img.getAttribute("src");
                if (
                  currentSrc &&
                  !currentSrc.includes("/img/profile-photo-default.png") &&
                  !currentSrc.includes("/img/empty_dealer_logo.png")
                ) {
                  const timestamp = Date.now();
                  const newSrc = currentSrc.split("?")[0] + "?v=" + timestamp;
                  img.setAttribute("src", newSrc);
                }
              });

            // Also refresh the left menu avatar if it exists
            const leftMenuAvatar = document.querySelector(
              ".left-menu-dealer-avatar img"
            );
            if (leftMenuAvatar) {
              const currentSrc = leftMenuAvatar.getAttribute("src");
              if (
                currentSrc &&
                !currentSrc.includes("/img/empty_dealer_logo.png")
              ) {
                const timestamp = Date.now();
                const newSrc = currentSrc.split("?")[0] + "?v=" + timestamp;
                leftMenuAvatar.setAttribute("src", newSrc);
              }
            }
          }, 100); // Small delay to ensure the upload is processed
        },
        error: function (xhr, status, error) {
          showNotification("Avatar image was not updated", "error");
        },
      }).always(function () {
        // Reset button state
        $button.removeClass("uploading").prop("disabled", false).text("Update");
        // This code will run whether the request succeeds or fails
        triggerUpdateOfDealerProfile();
      });
    });
  }

  function triggerUpdateOfDealerProfile() {
    $("#update-dealer-profile-info").trigger("click");
  }

  function loadDealerProfileView() {
    // Make an AJAX call to load the form from the controller
    $.ajax({
      url: "/DealerEditProfile/UpdateProfile",
      type: "GET",
      success: function (response) {
        // Load the form into the container
        $(".dealer-profile-info-container").html(response);
        initializeDealerProfileFormHandlers();
      },
      error: function (error) {
        showNotification("User profile was not loaded", "error");
      },
    });
  }

  loadDealerProfileView();

  function initializeDealerProfileFormHandlers() {
    $("#update-dealer-profile-info").on("click", function () {
      // Collect the form data
      var form = $("#profileDealerUpdateForm");
      var formData = form.serialize();

      // Send the form via AJAX
      $.ajax({
        url: "/DealerEditProfile/UpdateProfile", // The action method that handles the form submission
        type: "POST",
        data: formData,
        success: function (response) {
          $(".dealer-profile-info-container").html(response);
          initializeDealerProfileFormHandlers();
        },
        error: function (xhr, status, error) {
          showNotification("User profile was not updated", "error");
        },
      });
    });
  }

  function loadSocialNetworkChangeView() {
    // Make an AJAX call to load the form from the controller
    $.ajax({
      url: "/DealerEditProfile/SetSocialNetworksForUser",
      type: "GET",
      success: function (response) {
        // Load the form into the container
        $(".dealer-social-networks-container").html(response);
        initializeChangeSocialNetworksFormHandlers();
      },
      error: function (error) {
        showNotification("Social networks form was not loaded", "error");
      },
    });
  }

  loadSocialNetworkChangeView();

  function loadConfirmChangesView() {
    // Make an AJAX call to load the form from the controller
    $.ajax({
      url: "/DealerEditProfile/GetConfirmPasswordToSaveChangesForm",
      type: "GET",
      success: function (response) {
        // Load the form into the container
        $(".confirm-changes-container").html(response);
        initializeConfirmChangesViewFormHandlers();
      },
      error: function (error) {
        showNotification("Confirm changes form was not loaded", "error");
      },
    });
  }

  loadConfirmChangesView();

  function initializeConfirmChangesViewFormHandlers() {
    $("#ConfirmPasswordToSaveChangesForm #toggle-password-icon").on(
      "mousedown",
      function () {
        var passwordInput = $("#ConfirmPasswordToSaveChangesForm #Password");
        var icon = $(this).find("i");
        icon.removeClass("fa-eye-slash").addClass("fa-eye");
        passwordInput.attr("type", "text"); // Show the password while the button is pressed
      }
    );

    $("#ConfirmPasswordToSaveChangesForm #toggle-password-icon").on(
      "mouseup mouseleave",
      function () {
        var passwordInput = $("#ConfirmPasswordToSaveChangesForm #Password");
        var icon = $(this).find("i");
        icon.removeClass("fa-eye").addClass("fa-eye-slash");
        passwordInput.attr("type", "password"); // Hide the password when the button is released
      }
    );

    $("#confirm-password-to-save-changes-button").on("click", function () {
      // Collect all form data including password confirmation
      var passwordForm = $("#ConfirmPasswordToSaveChangesForm");
      var profileForm = $("#profileDealerUpdateForm");
      var socialForm = $("#SetSocialNetworksForUser");
      var passwordChangeForm = $("#setNewPasswordFromAccountForm");
      var avatarForm = $("#avatarImageUpdateForm");

      // Create FormData to handle file uploads
      var formData = new FormData();

      // Add password confirmation
      formData.append(
        "Password",
        passwordForm.find("input[name='Password']").val()
      );

      // Add profile data
      if (profileForm.length > 0) {
        profileForm.serializeArray().forEach(function (field) {
          formData.append("Profile." + field.name, field.value);
        });
      }

      // Add social networks data
      if (socialForm.length > 0) {
        socialForm.serializeArray().forEach(function (field) {
          formData.append("SocialNetworks." + field.name, field.value);
        });
      }

      // Add password change data
      if (passwordChangeForm.length > 0) {
        passwordChangeForm.serializeArray().forEach(function (field) {
          formData.append("PasswordChange." + field.name, field.value);
        });
      }

      // Add avatar file if selected
      var avatarFileInput = avatarForm.find("input[type='file']");
      if (avatarFileInput.length > 0 && avatarFileInput[0].files.length > 0) {
        var file = avatarFileInput[0].files[0];
        var maxSize = 1024 * 1024; // 1MB in bytes

        // Check file size
        if (file.size > maxSize) {
          showNotification("Avatar file size must be less than 1MB", "error");
          return;
        }

        formData.append("AvatarFile", file);
      }

      // Add anti-forgery token
      var token = $("input[name='__RequestVerificationToken']").val();
      if (token) {
        formData.append("__RequestVerificationToken", token);
      }

      // Send all data via AJAX with password validation
      $.ajax({
        url: "/DealerEditProfile/SaveAllChanges", // New secure endpoint that validates password
        type: "POST",
        data: formData,
        processData: false,
        contentType: false,
        success: function (response) {
          showNotification("Changes saved successfully!", "success");
          // Refresh the page after a short delay
          setTimeout(function () {
            window.location.reload();
          }, 1500);
        },
        error: function (xhr, status, error) {
          var errorMessage = "Error saving changes. Please try again.";
          if (xhr.responseJSON && xhr.responseJSON.message) {
            errorMessage = xhr.responseJSON.message;
          }
          showNotification(errorMessage, "error");
        },
      });
    });
  }

  // Function to submit all other forms on the page
  function submitAllForms() {
    // Only submit avatar if a file is actually selected
    var avatarFileInput = $("#avatarImageUpdateForm input[type='file']");
    if (avatarFileInput.length > 0 && avatarFileInput[0].files.length > 0) {
      $("#updateAvatarImage").trigger("click");
    }

    $("#set-social-networks-for-user-button").trigger("click");
    $("#set-new-password-from-account-button").trigger("click");
    $("#update-dealer-profile-info").trigger("click");
  }
}
